import { FormInputField } from "@/components/ui/form-input-field"
import { FormSectionHeader } from "@/components/ui/form-section-header"
import { FormSelectField } from "@/components/ui/form-select-field"
import { FormTextareaField } from "@/components/ui/form-textarea-field"

import { ConsumptionTypeField } from "./ConsumptionTypeField"
import type { ProductFieldGroupProps, ProductFormOption } from "./product-field-types"

interface ProductBasicFieldsProps extends ProductFieldGroupProps {
  readOnlyName: boolean
  categoryOptions: ProductFormOption[]
  providerOptions: ProductFormOption[]
}

export function ProductBasicFields({
  control,
  labels,
  readOnlyName,
  categoryOptions,
  providerOptions,
}: ProductBasicFieldsProps) {
  return (
    <section>
      <FormSectionHeader number="01" title={labels.section1Title} />
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
        <FormInputField
          control={control}
          name="name"
          label={labels.name + " *"}
          disabled={readOnlyName}
          placeholder={labels.namePlaceholder}
          className="col-span-1"
        />
        <FormInputField
          control={control}
          name="sku"
          label={labels.sku + " *"}
          placeholder={labels.skuPlaceholder}
          className="col-span-1"
        />
        <div className="col-span-1 space-y-2 md:col-span-2">
          <FormTextareaField
            control={control}
            name="description"
            label={labels.description}
            placeholder={labels.descPlaceholder}
            rows={5}
          />
        </div>
        <FormSelectField
          control={control}
          name="categoryId"
          label={labels.category + " *"}
          options={categoryOptions}
          placeholder={labels.selectCategory}
          className="col-span-1"
        />
        <FormSelectField
          control={control}
          name="providerId"
          label={labels.provider}
          options={providerOptions}
          placeholder={labels.selectProvider}
          className="col-span-1"
        />
        <ConsumptionTypeField control={control} labels={labels} />
      </div>
    </section>
  )
}
